import { wantPickerHint } from 'utils/component-picker-options';
import { SystemTypeOption } from 'utils/recommendations-strip-logic';
import { CompositionPicks } from 'utils/system-composition-types';

type WantPickerReadoutProps = {
  resolved: SystemTypeOption | null;
  picks: CompositionPicks;
};

// The composed-type readout under the want component picker: names the
// system type the current picks resolve to, or hints at what's missing.
// Left-border color coding mirrors the have card's ReadoutBar — green when
// a type resolved, gray while composing.
export default function WantPickerReadout({
  resolved,
  picks
}: WantPickerReadoutProps) {
  return (
    <div
      data-testid='want-picker-readout'
      className={`rounded-r border-l-[3px] bg-white px-3 py-1.5 text-xs text-gray-600 ${
        resolved ? 'border-l-green-600' : 'border-l-gray-300'
      }`}
    >
      {resolved ? (
        <>
          Your system: <b className='text-gray-900'>{resolved.name}</b>
        </>
      ) : (
        wantPickerHint(picks)
      )}
    </div>
  );
}
